module.exports = __webpack_public_path__ + "static/img/1000000438_red.812b2ba7.jpg";